import {
  Notification,
  NotificationAnalytics as NotificationAnalyticsModel,
} from '@models/Notification'
import { fetchAnalyticsForNotification } from '@services/NotificationService'
import { useAppSelector } from '@store/hooks'
import { selectNotificationById } from '@store/NotificationReducer'
import { SBModelComponent } from '@supplement-bacon/react-toolkit/models'
import { numberFormat } from '@utils/currencyFormatter'
import { Space, Spin, Typography } from 'antd'
import dayjs from 'dayjs'
import { useEffect, useState } from 'react'

const { Text } = Typography

type Props = SBModelComponent<Notification> & {}

const NotificationAnalytics = ({ id, model }: Props) => {
  const item = model ?? useAppSelector(selectNotificationById(id!))

  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [data, setData] = useState<NotificationAnalyticsModel | undefined>(
    undefined
  )

  useEffect(() => {
    if (!item) return
    setIsLoading(true)
    fetchAnalyticsForNotification(item)
      .then((response) => {
        setData(response.data)
      })
      .finally(() => {
        setIsLoading(false)
      })
  }, [])

  if (!item) return <></>

  return (
    <Space size={40}>
      {isLoading && <Spin />}
      {!isLoading && (
        <Space size={25}>
          <Space orientation="vertical" size={0}>
            <Text type="secondary">Sent</Text>
            <Text>{numberFormat(item.sentTo)}</Text>
          </Space>
          <Space orientation="vertical" size={0}>
            <Text type="secondary">Opening rate</Text>
            <Text>{data?.openingRate}%</Text>
          </Space>
          <Space orientation="vertical" size={0}>
            <Text type="secondary">Date</Text>
            <Text>{dayjs(item.sentAt).format('DD MMM YYYY HH:mm')}</Text>
          </Space>
          {/* <BarChart
            width={200}
            height={50}
            data={(data?.chartData ?? []).map((e) => ({ ...e, name: e.date }))}
          >
            <Tooltip />
            <Bar dataKey="opened" fill="#8e978a" />
          </BarChart> */}
        </Space>
      )}
    </Space>
  )
}

type NotificationAnalyticsType = { Analytics: typeof NotificationAnalytics }

export { NotificationAnalytics, type NotificationAnalyticsType }
